import React from "react";


const BulkActionsBar = ({ selectedRecords, store, onBulkAssign, onBulkDelete, onBulkApprove,onExportPDF, onExportExcel,onBulkNotify }) => {
  const hasAssign = store.getprops("update") && typeof onBulkAssign === "function";
  const hasDelete = store.getprops("delete") && typeof onBulkDelete === "function";
  const hasApprove = store.getprops("update") && typeof onBulkApprove === "function";
  const hasnotify =store.getprops("update") && typeof onBulkNotify === "function";

  if (selectedRecords.length === 0) {
    return null;
  }

  return (
    <div className="absolute bottom-2 left-4 flex gap-1 p-2 bg-[#F7F5F9] text-black shadow-xl rounded-md">
      <span className="text-sm  px-3 py-1 mr-2 flex items-center">
        {selectedRecords.length} items selected
      </span>
      {hasAssign && (
        <button
          className="text-sm px-3 py-1 rounded-full border-2 border-primary bg-secondary text-primary transition hover:bg-primary hover:text-secondary"
          onClick={onBulkAssign}
        >
          To Assign
        </button>
      )}
      {hasnotify && (
        <button
          className="text-sm px-3 py-1 rounded-full border-2 border-primary bg-secondary text-primary transition hover:bg-primary hover:text-secondary"
          onClick={onBulkNotify}
        >
          To Notify
        </button>
      )}
      {onExportPDF && (
        <button
          className="text-sm px-3 py-1 rounded-full border-2 border-primary bg-secondary text-primary hover:bg-primary hover:text-secondary"
          onClick={onExportPDF}
        >
          Export PDF
        </button>
      )}

      {onExportExcel && (
        <button
          className="text-sm px-3 py-1 rounded-full border-2 border-primary bg-secondary text-primary hover:bg-primary hover:text-secondary"
          onClick={onExportExcel}
        >
          Export Excel
        </button>
      )}
       {hasApprove && (
        <button
          className="text-sm px-3 py-1 rounded-full border-2 border-primary bg-secondary text-primary transition hover:bg-primary hover:text-secondary"
          onClick={onBulkApprove}
        >
          To Approve
        </button>
      )}
      {hasDelete && (
        <button
          className="text-sm px-3 py-1 rounded-full border-2 border-primary bg-secondary text-primary transition hover:bg-primary hover:text-secondary"
          onClick={onBulkDelete}
        >
          To Delete
        </button>
      )}
     
    </div>
  );
};

export default BulkActionsBar;